<template>
  <form class="password-form" @submit.prevent="save">
    <v-alert v-if="error" type="error" variant="tonal" class="mb-3">{{ error }}</v-alert>
    <v-alert v-if="success" type="success" variant="tonal" class="mb-3">Passwort erfolgreich geändert.</v-alert>
    <v-text-field v-model="oldPassword" label="Aktuelles Passwort" type="password"
                  variant="outlined" density="comfortable" autocomplete="current-password" :disabled="saving" required />
    <v-text-field v-model="newPassword" label="Neues Passwort" type="password"
                  variant="outlined" density="comfortable" autocomplete="new-password" :disabled="saving" required />
    <v-text-field v-model="confirmation" label="Neues Passwort wiederholen" type="password"
                  variant="outlined" density="comfortable" autocomplete="new-password" :disabled="saving" required />
    <div class="password-actions">
    <v-btn type="submit" color="primary" variant="flat" :loading="saving"
           :disabled="saving || !oldPassword || !newPassword || !confirmation">Passwort ändern</v-btn>
    </div>
  </form>
</template>

<script>
export default {
  name: 'PasswordChangeForm',
  data: () => ({ oldPassword: '', newPassword: '', confirmation: '', saving: false, error: '', success: false }),
  methods: {
    async save() {
      if (this.saving) return
      this.error = ''
      this.success = false
      if (!this.oldPassword || !this.newPassword || !this.confirmation) {
        this.error = 'Bitte alle Passwortfelder ausfüllen.'
        return
      }
      if (this.newPassword !== this.confirmation) {
        this.error = 'Die neuen Passwörter stimmen nicht überein.'
        return
      }
      this.saving = true
      try {
        await this.$store.dispatch('changeUserPassword', {
          oldPassword: this.oldPassword, newPassword: this.newPassword,
        })
        this.oldPassword = this.newPassword = this.confirmation = ''
        this.success = true
      } catch (error) {
        const status = error?.response?.status
        // Keine Axios-Fehlerobjekte protokollieren: sie enthalten den Passwort-Request.
        this.error = status === 401
          ? 'Das aktuelle Passwort ist falsch oder die Sitzung ist abgelaufen.'
          : status === 422
            ? 'Die Anfrage wurde abgelehnt. Passwortvorgaben prüfen; vor dem Backend-Update ist der neue Passwortwechsel noch nicht verfügbar.'
            : `Passwort konnte nicht geändert werden${status ? ` (HTTP ${status})` : ''}. Bitte erneut versuchen.`
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.password-form { width: 100%; max-width: 520px; }
.password-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-top: 16px; }
</style>
